import Eximlist from '../components/modules/eximlist';

const eximlist = [
  {
    path: '/eximlist',
    name: 'Eximlist',
    component: Eximlist,
    meta: {
      title: 'Ex-Im',
    },
  },
];
export default eximlist;
